import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    borderTop: `1px solid ${colors.space15}`,
    minHeight: '220px',

    maxWidthMobile: {
      minHeight: '160px',
    },
  },
});

export default styles;
